import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'

export default {
  name: 'ChangedValueIndicator',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: 0,
        },
      },
    },
    previousValue: {
      configSet: Text,
      configValues: {},
    },
    newValueContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    newValue: {
      configSet: Text,
      configValues: {},
    },
    indicationIconContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          minWidth: '12px',
          minHeight: '12px',
          height: '12px',
          width: '12px',
          justifyContent: 'center',
          alignItems: 'center',
          _mobile_minHeight: '17px',
        },
      },
    },
    indicationIcon: {
      configSet: Image,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
